/*
 * Created by Joseph.Saliba on 4/6/15.
 */
import { Factory } from '../../services/Factory';

namespace app.directives.controls {

  export interface IProgressScope extends angular.IScope {
    totalPercentageComplete: () => number;
    isLoggedIn: boolean;
    tasks: app.model.monitoring.IMonitorable[];
  }

  export class Progress implements angular.IDirective {
    public restrict: string = 'EAC';
    public templateUrl: string;
    public scope = {ngModel: '='};
    public link: (scope: angular.IScope) => void;

    constructor(stateService: app.services.state.StateService) {
      this.templateUrl = 'partials/progress.html';
      this.link = (scope: IProgressScope) => {

        scope.totalPercentageComplete = (): number => {
          if (!scope.tasks) {
            return 0;
          }

          let total: number = 0;

          angular.forEach(scope.tasks, (item: app.model.monitoring.IMonitorable) => {
            total += item.job.percentageComplete;
          });

          return total / scope.tasks.length;
        };

        scope.isLoggedIn = !stateService.IsLoggedOut();

        scope.$on(EVENTS.LOGIN_CONFIRMED, () => {
          scope.isLoggedIn = true;
        });

        scope.$on(EVENTS.LOGIN_REQUIRED, () => {
          scope.isLoggedIn = false;
        });

        scope.$on('MonitorableUpdated', (e: any, item: app.model.monitoring.IMonitorable) => {
          if (!scope.tasks) {
            scope.tasks = [];
          }

          let task: app.model.monitoring.IMonitorable = _.findWhere(scope.tasks, {id: item.id});
          if (!task) {
            scope.tasks.push(item);
          } else {
            task.job.percentageComplete = item.job.percentageComplete;
            scope.$applyAsync();
          }
        });

        scope.$on('MonitorableCompleted', (e: any, item: app.model.monitoring.IMonitorable) => {
          scope.tasks = _.without(scope.tasks, _.findWhere(scope.tasks, {id: item.id}));
        });
      }
    }
  }

  frontendApp.directive("iioProgress", ['StateService', Factory.Create(Progress)]);
}
